<template>
  <div class="table-item">
    <cell-renderer v-if="hasRendererFunction" :column="column" :data="data"></cell-renderer>
    <template v-else-if="hasRendererComponent">
      <component :is="column.cellRenderer" :column="column" :data="data"></component>
    </template>
    <template v-else>
      {{ value }}
    </template>
  </div>
</template>

<script>
import Column from './Column';

export default {
  name: 'TableCell',
  props: {
    column: {
      type: Object,
      default: () => new Column()
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    hasRendererFunction() {
      return (
        this.column && this.column.cellRenderer && typeof this.column.cellRenderer === 'function'
      );
    },
    hasRendererComponent() {
      return (
        this.column && this.column.cellRenderer && typeof this.column.cellRenderer === 'object'
      );
    },
    value() {
      return this.data && this.column ? this.column.getValue(this.data) : null;
    }
  },
  created() {
    if (this.hasRendererFunction) {
      this.$options.components.cellRenderer = {
        props: ['column', 'data'],
        render: this.column.cellRenderer
      };
    }
  }
};
</script>
